/**
 * Ürün adı TEK yerde. İsim kararı ertelendi (MIMARI §15-2); mesajlarda `{product}` olarak geçer
 * ve çevirmen bunu otomatik doldurur. Ad değişince yalnız bu satır değişir.
 */
export const PRODUCT_NAME = 'Destera';
